import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDropOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 38,
	height: 57,
	viewBox: "0 0 38 57",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19 3.5C20.0468 3.5 21.6529 4.22388 23.7012 6.69531C25.6682 9.06868 27.5569 12.4879 29.208 16.4199C32.5342 24.3413 34.5 33.3671 34.5 38C34.5 46.5604 27.5604 53.5 19 53.5C10.4396 53.5 3.5 46.5604 3.5 38C3.5 33.3671 5.46575 24.3413 8.79199 16.4199C10.4431 12.4879 12.3318 9.06868 14.2988 6.69531C16.3471 4.22388 17.9532 3.5 19 3.5Z",
		stroke: "#B44359",
		strokeWidth: 7
	})
});
export default SvgDropOutline;
